import React, { useState } from "react";

import "./style.css";
import { DeleteIcon } from "@chakra-ui/icons";
import {
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalFooter,
	ModalBody,
	ModalCloseButton,
	useDisclosure,
	Button,
	Image,
	Stack,
	Box,
	Badge,
	Text,
	SimpleGrid,
	Center,
	IconButton,
	useColorModeValue,
} from "@chakra-ui/react";
import moment from "moment";

import { fullDateFormat } from "../../utils/types";

export default function Gallery({ items, handleMediaDelete }) {
	const [selectedItem, setSelectedItem] = useState(null);
	const { isOpen, onOpen, onClose } = useDisclosure();
	const bgColor = useColorModeValue("white", "gray.800");
	const borderColor = useColorModeValue("gray.200", "gray.700");

	const handleItemClick = (item) => {
		setSelectedItem(item);
		onOpen();
	};

	const MediaCard = ({ item }) => (
		<Box
			position="relative"
			cursor="pointer"
			borderRadius="lg"
			overflow="hidden"
			border="1px solid"
			borderColor={borderColor}
			transition="all 0.3s"
			_hover={{
				transform: "translateY(-2px)",
				boxShadow: "lg",
			}}
			height="200px"
		>
			{item.contentType.includes("image") ? (
				<>
					<Badge position="absolute" top="2" left="2" colorScheme="teal" variant="solid" borderRadius="full" px="2" zIndex="1">
						Image
					</Badge>
					{item.type && (
						<Badge position="absolute" top="2" right="2" colorScheme="red" variant="solid" borderRadius="full" px="2" zIndex="1">
							{item.type}
						</Badge>
					)}
					<Image src={item.url} alt={item.name} objectFit="cover" w="100%" h="100%" transition="transform 0.3s" _hover={{ transform: "scale(1.05)" }} />
				</>
			) : item.contentType.includes("pdf") ? (
				<Center h="100%" bg={bgColor} p="4">
					<Badge colorScheme="purple" variant="solid" fontSize="lg" p="2">
						PDF Document
					</Badge>
				</Center>
			) : (
				<Box position="relative" h="100%">
					<Badge position="absolute" top="2" left="2" colorScheme="yellow" variant="solid" borderRadius="full" px="2" zIndex="1">
						Video
					</Badge>
					<video
						src={item.url}
						style={{
							width: "100%",
							height: "100%",
							objectFit: "cover",
						}}
					/>
				</Box>
			)}
			{item.addedDate && (
				<Text position="absolute" bottom="2" left="2" fontSize="xs" color="white" bg="blackAlpha.700" px="2" py="1" borderRadius="md">
					{moment(item.addedDate).format(fullDateFormat)}
				</Text>
			)}
		</Box>
	);

	return (
		<Box p="4">
			<SimpleGrid columns={{ base: 1, sm: 2, md: 3, lg: 4 }} spacing="4">
				{items.map((item) => (
					<Box key={item.id} onClick={() => handleItemClick(item)}>
						<MediaCard item={item} />
					</Box>
				))}
			</SimpleGrid>

			{selectedItem && (
				<Modal onClose={onClose} isOpen={isOpen} isCentered size="6xl" scrollBehavior="inside" motionPreset="slideInBottom">
					<ModalOverlay bg="blackAlpha.800" backdropFilter="blur(10px)" />
					<ModalContent bg={bgColor}>
						<ModalHeader borderBottom="1px solid" borderColor={borderColor}>
							<Stack spacing="4">
								<Text fontSize="xl" fontWeight="bold">
									Media Preview
								</Text>
								<Stack direction="row" spacing="4" alignItems="center">
									{selectedItem.type && (
										<Badge colorScheme="red" fontSize="md" px="3" py="1">
											{selectedItem.type}
										</Badge>
									)}
									{selectedItem.addedDate && (
										<Badge colorScheme="green" fontSize="md" px="3" py="1">
											{moment(selectedItem.addedDate).format(fullDateFormat)}
										</Badge>
									)}
								</Stack>
							</Stack>
						</ModalHeader>
						<ModalCloseButton />
						<ModalBody p="6">
							<Center>
								{selectedItem.contentType.includes("image") ? (
									<Image src={selectedItem.url} alt={selectedItem.name} maxH="70vh" objectFit="contain" borderRadius="md" />
								) : selectedItem.contentType.includes("pdf") ? (
									<iframe src={selectedItem.url} width="100%" height="70vh" style={{ border: "none", borderRadius: "8px" }} />
								) : (
									<video
										src={selectedItem.url}
										controls
										style={{
											maxHeight: "70vh",
											borderRadius: "8px",
											backgroundColor: "black",
										}}
									/>
								)}
							</Center>
						</ModalBody>
						<ModalFooter borderTop="1px solid" borderColor={borderColor}>
							<Stack direction="row" spacing="3">
								{typeof handleMediaDelete === "function" && (
									<IconButton
										icon={<DeleteIcon />}
										colorScheme="red"
										onClick={() => {
											onClose();
											handleMediaDelete(selectedItem);
										}}
										aria-label="Delete media"
									/>
								)}
								<Button onClick={onClose} size="md">
									Close
								</Button>
							</Stack>
						</ModalFooter>
					</ModalContent>
				</Modal>
			)}
		</Box>
	);
}
